const auth_de = {
  title: 'Melden Sie sich am Konto an',
  subtitle: 'Bitte geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein, um fortzufahren.',
  login: 'Anmelden',
  form: {
    emailAddress: 'E-Mail-Adresse',
    emailAddressPlaceholder: 'Geben Sie Ihre E-Mail-Adresse ein',
    emailAddressInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    emailAddressRequired: 'E-Mail-Adresse ist erforderlich',
    password: 'Passwort',
    passwordPlaceholder: 'Geben Sie Ihr Passwort ein',
    passwordInvalid: 'Bitte geben Sie ein gültiges Passwort ein',
    passwordRequired: 'Passwort ist erforderlich',
    submit: 'Anmelden',
    forgotPassword: 'Passwort vergessen?',
    resetPassword: 'Jetzt zurücksetzen',
  },
  validation: {
    emailAddress: {
      invalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      required: 'E-Mail-Adresse ist erforderlich',
      min: 'E-Mail-Adresse muss mindestens 3 Zeichen lang sein',
      max: 'E-Mail-Adresse muss höchstens 255 Zeichen lang sein',
    },
    password: {
      invalid: 'Bitte geben Sie ein gültiges Passwort ein',
      required: 'Passwort ist erforderlich',
      min: 'Passwort muss mindestens 3 Zeichen lang sein',
      max: 'Passwort muss höchstens 24 Zeichen lang sein',
      lowercase: 'Passwort muss ein Kleinbuchstaben enthalten',
    },
  },
  messages: {
    formInvalid: 'Formular ist ungültig.',
    loginSuccessful: 'Anmeldung erfolgreich.',
    loginFailed: 'Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldeinformationen.',
    accessDenied: 'Zugriff verweigert. Dieses Portal ist nur für Kunden.',
  },
  forgot: {
    title: 'Passwort vergessen',
    subtitle: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
    emailAddress: 'E-Mail-Adresse',
    send: 'Senden',
    message: 'Eine E-Mail wurde an Ihre E-Mail-Adresse gesendet.'
  },
  sent: {
    title: 'E-Mail gesendet',
    subtitle: 'Wir haben Ihnen Anweisungen zum Zurücksetzen Ihres Passworts gesendet an',
    ok: 'OK'
  },
  reset: {
    title: 'Passwort zurücksetzen',
    subtitle: 'Bitte geben Sie Ihr neues Passwort ein.',
    newPassword: 'Neues Passwort',
    warningMessagesOne: 'Mindestens 8 Zeichen.',
    warningMessagesTwo: 'Mindestens ein Großbuchstabe und eine Zahl.',
    warningMessagesThree: 'Keine Leerzeichen erlaubt.',
    confirmNewPassword: 'Neues Passwort bestätigen',
    reset: 'Zurücksetzen',
    passwordNotStrong: 'Ihr Passwort ist nicht sicher genug.',
    passwordNotMatch: 'Die Passwörter stimmen nicht überein.',
    message: 'Das Passwort wurde erfolgreich zurückgesetzt.',
    failed: 'Das Passwort konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    link: {
      checking: 'Link wird geprüft…',
      requestNewLink: 'Neuen Link anfordern',
      backToLogin: 'Zurück zur Anmeldung',
      expired: {
        title: 'Link abgelaufen',
        text: 'Dieser Link ist abgelaufen – Links zum Festlegen des Passworts sind 48 Stunden gültig. Fordern Sie einfach einen neuen an.',
      },
      invalid: {
        title: 'Link nicht mehr gültig',
        text: 'Dieser Link wurde bereits verwendet oder durch eine neuere E-Mail ersetzt. Verwenden Sie den Link aus der neuesten E-Mail oder fordern Sie einen neuen an.',
      },
      inactive: {
        title: 'Konto nicht aktiv',
        text: 'Ihr Konto ist derzeit nicht aktiv. Bitte wenden Sie sich an LA CONCEPT.',
      },
    },
    validation: {
      password: {
        notEnough: 'Ihr Passwort ist nicht sicher genug.',
        invalid: 'Bitte geben Sie ein gültiges Passwort ein.',
        required: 'Passwort ist erforderlich.',
        min: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
        lowercase: 'Das Passwort muss einen Kleinbuchstaben enthalten.',
        uppercase: 'Das Passwort muss einen Großbuchstaben enthalten.',
        number: 'Das Passwort muss eine Zahl enthalten.',
        noSpace: 'Leerzeichen sind nicht erlaubt.',
        notMatch: 'Die Passwörter stimmen nicht überein.'
      }
    }
  },
  changed: {
    title: 'Passwort geändert',
    subtitle: 'Ihr Passwort wurde erfolgreich geändert.',
    backToLogin: 'Zurück zur Anmeldung'
  },
  changePassword: {
    menu: 'Passwort ändern',
    title: 'Passwort ändern',
    confirm: 'Wir senden einen Link zum Ändern Ihres Passworts an {email}.',
    send: 'Link senden',
    cancel: 'Abbrechen',
    close: 'Schließen',
    sent: 'Wir haben eine E-Mail an {email} gesendet. Über den Link darin legen Sie ein neues Passwort fest. Sie bleiben bis dahin angemeldet.',
  },
}

export default auth_de
